import { Validators } from '@angular/forms';

export interface ResultLoginInterface {
  message: string;
  success: boolean;
  data: LoginInterface;
  errors: any[];
}

export class LoginInterface {
  codigoEmpresa: number = 0;
  codigoMaquina: number = 0;
  codigoUsuario: number = 0;
  sequencia: string = '';
  usuario: string = '';
  codigoCentroTrabalho: number = 0;
  descricaoCentroTrabalho: string = '';
  token: string = '';
  perfil: boolean = false;
  expireValue: number = 0;
  expireToken: string = '';
  foto: string = '';

  setCentroTrabalho(codigos: any) {
    this.codigoCentroTrabalho = Number(codigos);
  }

  getCentroTrabalho(): number {
    return this.codigoCentroTrabalho;
  }
} 

export class FormLoginInterface {
  public usuario = ['', [Validators.required]];
  public senha = ['', [Validators.required]];
  public cboUnidadeValue = ['']; 
}
